import { render, staticRenderFns } from "./xlmjTable.vue?vue&type=template&id=475db914&scoped=true"
import script from "./xlmjTable.vue?vue&type=script&lang=ts"
export * from "./xlmjTable.vue?vue&type=script&lang=ts"
import style0 from "./xlmjTable.vue?vue&type=style&index=0&id=475db914&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475db914",
  null
  
)

export default component.exports